<form [formGroup]="formGroup">
  <div fxLayout="column">
    <ng-container *ngIf="questions?.length; else noQuestionsEl">
      <div fxLayout="column">
        <div class="mb-5" *ngIf="canUseAi">
          <ng-container *ngIf="(error$ | async) as error; else statusEl">
            <div class="text-center status-text error mb-5">
              {{ error | translate }}
            </div>
            <ng-container [ngTemplateOutlet]="aiLabelEl"></ng-container>
          </ng-container>

          <ng-template #statusEl>
            <div *ngIf="currentAnswerStep$ | async as step; else aiLabelEl" class="text-center status-text">
              {{ 'dialog.authorizations.ai-step.' + step | translate }}
            </div>
          </ng-template>

          <ng-template #aiLabelEl>
            <div fxLayout="row" fxLayoutAlign="space-between center" class="ai-button-container">
              <div class="text-center">
                {{ 'dialog.authorizations.ai-step.hint' | translate }}
              </div>
              <button
                mat-fab
                color="primary"
                (click)="onAnswerQuestions(portal)"
                [disabled]="currentAnswerStep$ | async"
                class="ai-button"
              >
                <mat-icon>bolt</mat-icon>
              </button>
            </div>
          </ng-template>
        </div>

        <div *ngFor="let question of questions">
          <div fxLayout="column" *ngIf="question.portalIds.includes(portal.portalSystemId)">
            <ng-container [ngSwitch]="question.type">
              <div *ngSwitchCase="'boolean'" fxLayout="column" class="mb-5">
                <mat-label>{{ question.content }}</mat-label>
                <mat-radio-group [formControlName]="question.id">
                  <mat-radio-button value="yes">{{ 'common.yes' | translate }}</mat-radio-button>
                  <mat-radio-button value="no">{{ 'common.no' | translate }}</mat-radio-button>
                </mat-radio-group>
                <mat-hint *ngIf="getHint(question) as hint">
                  {{ hint | translate }}
                </mat-hint>
              </div>

              <div *ngSwitchCase="'select'" fxLayout="column" class="mb-5">
                <mat-label>{{ question.content }}</mat-label>
                <mat-radio-group [formControlName]="question.id" fxLayout="column">
                  <mat-radio-button fxFlex *ngFor="let answer of question.answers" [value]="answer">
                    {{ answer }}
                  </mat-radio-button>
                </mat-radio-group>
                <mat-hint *ngIf="getHint(question) as hint">
                  {{ hint | translate }}
                </mat-hint>
              </div>

              <div *ngSwitchCase="'multi-select'" fxLayout="column" class="mb-5">
                <mat-label>{{ question.content }}</mat-label>
                <mat-checkbox-group fxLayout="column">
                  <mat-checkbox
                    fxFlex
                    *ngFor="let answer of question.answers; let i = index"
                    [formControlName]="question.id + '--' + i"
                  >
                    {{ answer }}
                  </mat-checkbox>
                </mat-checkbox-group>
                <mat-hint *ngIf="getHint(question) as hint">
                  {{ hint | translate }}
                </mat-hint>
              </div>

              <mat-form-field *ngSwitchDefault class="mb-5" fxFlex>
                <mat-label>{{ question.content }}</mat-label>
                <input matInput [formControlName]="question.id" />
                <mat-hint *ngIf="getHint(question) as hint">
                  {{ hint | translate }}
                </mat-hint>
              </mat-form-field>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #noQuestionsEl>
      <div class="text-center py-5">
        {{ 'dialog.authorizations.portal-questions.no-questions' | translate }}
      </div>
    </ng-template>
  </div>
</form>
